import * as React from "react";
const SvgPlayIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 16, viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.546875 13.7789C0.576549 15.1896 1.91372 16.0439 3.0852 15.3724L12.5059 9.59539C13.0189 9.28036 13.3671 8.70296 13.3671 8.02656C13.3671 7.34995 13.0189 6.77272 12.5059 6.45772L3.0852 0.688549C1.91367 0.017039 0.576533 0.862935 0.546875 2.27387V13.7789Z", fill: "currentColor" }));
export default SvgPlayIcon;
